<template>
  <LayoutDefault>
    <template v-slot:main>
      <h5 class="bv-fgts__page-title">Consulta FGTS</h5>

      <br>

      <b-form @submit.prevent="fetchData">

        <b-row>

          <b-col cols="3">
            <b-form-group
              label="CPF"
              label-for="cpf-input"
            >
              <b-form-input
                id="cpf-input"
                v-model="form.cpf"
                type="text"
                required
                v-mask="'###.###.###-##'"
                placeholder=""
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="2">
            <b-form-group
              label="Prestações"
              label-for="periods-input"
            >
              <b-form-input
                id="periods-input"
                v-model="form.periods"
                type="number"
                min="1"
                required
                placeholder="10"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-button
          @click="fetchData()"
          type="submit"
          pill
        >
          Consultar
        </b-button>

        <template v-if="loading">
          <div class="bv-fgts__loader">
            <BaseLoaderDefault/>
          </div>
        </template>
        <div
          v-else-if="dataset"
          class="bv-fgts__summary"
        >
          <div v-if="dataset.status === 'success'">

            <div class="bv-fgts__section">
              <p class="bv-fgts__summary-section-title">Resumo da Simulação</p>

              <table>
                <tbody>
                  <tr>
                    <td>Valor a antecipar</td>
                    <td>{{ dataset.data.valorTotal | currency }}</td>
                  </tr>
                  <tr>
                    <td>Número de parcelas adiantadas</td>
                    <td>{{ dataset.data.qtdParcelas | number }} saques</td>
                  </tr>
                  <tr>
                    <td>Juros ao mês</td>
                    <td>{{ dataset.data.txNetBv | percentage }} a.m</td>
                  </tr>
                  <tr>
                    <td>Juros ao ano</td>
                    <td>{{ dataset.data.txJurosAno | percentage }} a.a</td>
                  </tr>
                  <tr>
                    <td>IOF</td>
                    <td>{{ dataset.data.valorIOF | currency }}</td>
                  </tr>
                  <tr>
                    <td>Valor da tarifa (TAC)</td>
                    <td>{{ dataset.data.tarifaValor | currency }}</td>
                  </tr>
                  <tr>
                    <td>Com seguro?</td>
                    <td>{{ dataset.data.comSeguro ? 'Sim' : 'Não' }}</td>
                  </tr>
                  <tr>
                    <td>Taxa de Custo Efetivo Total ao mês</td>
                    <td>{{ dataset.data.txCETMes | percentage }} a.m</td>
                  </tr>
                  <tr>
                    <td>Taxa de Custo Efetivo Total ao ano</td>
                    <td>{{ dataset.data.txCETAno | percentage }} a.a</td>
                  </tr>
                  <tr>
                    <td>Valor do Seguro</td>
                    <td>{{ dataset.data.valorSeguro | currency }}</td>
                  </tr>
                  <tr class="bv-fgts__table-final">
                    <td><b>Valor a receber</b></td>
                    <td><b>{{ dataset.data.valorLiquido | currency }}</b></td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="bv-fgts__section">
              <p class="bv-fgts__summary-section-title">Períodos</p>

              <table>
                <tbody>
                  <tr v-for="(periodo, index) in dataset.data.periodos" :key="index">
                    <td>{{ periodo.dataRepasse | date }}</td>
                    <td>{{ periodo.valor | currency }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="bv-fgts__section">
              <p class="bv-fgts__warning">
                Sua consulta foi salva junto com os dados abaixo:
              </p>

              <table>
                <tbody>
                  <tr>
                    <td>IP de acesso:</td>
                    <td>{{ dataset.requestInfos.sourceIp }}</td>
                  </tr>
                  <tr>
                    <td>Nome de usuário:</td>
                    <td>{{ dataset.requestInfos.userName }}</td>
                  </tr>
                  <tr>
                    <td>ID de usuário:</td>
                    <td>{{ dataset.requestInfos.id_user }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-else-if="dataset.status === 'error' && dataset.data">
            <p class="bv-fgts__summary-section-title">
              {{ dataset.data }}
            </p>

            <div class="bv-fgts__section">
              <p class="bv-fgts__warning">
                Sua consulta foi salva junto com os dados abaixo:
              </p>

              <table>
                <tbody>
                  <tr>
                    <td>IP de acesso:</td>
                    <td>{{ dataset.requestInfos.sourceIp }}</td>
                  </tr>
                  <tr>
                    <td>Nome de usuário:</td>
                    <td>{{ dataset.requestInfos.userName }}</td>
                  </tr>
                  <tr>
                    <td>ID de usuário:</td>
                    <td>{{ dataset.requestInfos.id_user }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-else>
            <p class="bv-fgts__summary-section-title">
              Erro ao consultar dados
            </p>
          </div>
        </div>
      </b-form>
    </template>
  </LayoutDefault>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import BaseLoaderDefault from "@/components/base/BaseLoaderDefault.vue";
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import { currencyFilter, numberFilter, percentageFilter, dateFilter } from '@/utils/filters'
import axios from 'axios';

export default {
  name: 'BvFgtsLookup',

  components: {
    LayoutDefault,
    BaseLoaderDefault
  },

  filters: {
    currency: currencyFilter,
    number: numberFilter,
    percentage: percentageFilter,
    date: dateFilter
  },

  data () {
    return {
      loading: false,
      form: {
        cpf: null,
        periods: 10
      },
      dataset: null
    };
  },

  methods: {
    async fetchData () {
      try {
        this.loading = true

        const endpoint = `${process.env.VUE_APP_ROOT_API}integration-bv/get-simulation/`

        if (this.form.cpf) {
          this.form.cpf = this.form.cpf.replace(/[.-]/g, '');
        }

        const response = await axios.post(endpoint, this.form, {headers: {'Authorization': `Bearer ${this.$auth.token()}`}});

        this.dataset = response.data
      } catch (e) {
        console.error(e)
        this.dataset = null
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.bv-fgts {
  color: #172542;

  &__loader {
    margin: 20px;
  }

  &__page-title {
    margin: 0;
    font-weight: bold;
  }

  &__summary{
    margin: 20px 0;
  }

  &__summary-section-title {
    margin: 25px 0 10px 0;
    font-weight: bold;
  }

  &__section {
    margin: 20px 0;
  }

  &__value {
    color: #172542aa
  }

  &__warning {
    font-weight: bold;
  }

  &__table-final {
    font-weight: 700;
  }
}

tr {
  border: 1px solid black;
}

td {
  border: 1px solid black;
  padding: 0 20px 0 5px;
}
</style>
